<template>
  <div class="flex flex-column border-1">
    <div class="flex text-2xl justify-content-center">CALC HZ TESTER</div>
    <div class="flex flex-column gap-4">
      <div class="flex flex-column gap-2">
        <div class="flex justify-content-center">
          VIA REFACTORED SCENARIO CALCS USING DESTRUCTURED SCENARIO
        </div>
        <div class="flex justify-content-around">
          <div class="flex gap-2">
            <Button @click="calcNewHz">CALC NEW HZ</Button>
            {{ theNewHz }}
          </div>
        </div>
      </div>
    </div>
    <DataTable :value="flowResultRows">
      <Column header="raw">
        <template #body="slotProps">
          <Button @click="showRaw(slotProps.data)">Raw</Button>
        </template>
      </Column>
      <Column header="frequency">
        <template #body="slotProps">{{
          slotProps.data.hypotheticalFrequencyHz
        }}</template>
      </Column>
      <Column header="produced">
        <template #body="slotProps">{{
          slotProps.data.producedPressurePSIA
        }}</template>
      </Column>
      <Column header="required">
        <template #body="slotProps">{{
          slotProps.data.requiredPressurePSIA
        }}</template>
      </Column>
      <Column header="pressureDifference">
        <template #body="slotProps">
          {{ slotProps.data.pressureDifference }}
        </template>
      </Column>
      <Column header="pressureDifferenceChange">
        <template #body="slotProps">
          {{ slotProps.data.pressureDifferenceChange }}
        </template>
      </Column>
      <Column field="isHealthy" header="isHealthy"></Column>
      <Column field="withinTolerance" header="withinTolerance"></Column>
      <Column field="depth" header="depth"></Column>
      <Column field="status" header="status"></Column>
    </DataTable>
  </div>
</template>

<script lang="ts" setup>
import {
  parametersFormKey,
  scenarioCalculationsKey
} from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict } from "@/utils/utils";
import { computed, ref } from "vue";
import { getPredictedDesiredFrequencyHz } from "../../../libs/calculations/predictiveCalcs/getPredictedDesiredPumpHz";
import type { HypotheticalFrequencyDataRow } from "@/libs/calculations/predictiveCalcs/getPredictedDesiredPumpHz/d";

const parametersForm = injectStrict(parametersFormKey);
const parameters = computed(() => parametersForm.data.value);

const _calcs = injectStrict(scenarioCalculationsKey);

const theNewHz = ref(0);
const flowResultRows = ref<HypotheticalFrequencyDataRow[]>([]);

const calcNewHz = () => {
  const theData = getPredictedDesiredFrequencyHz(_calcs, parameters.value);

  if (theData) {
    theNewHz.value = theData.targetRow?.hypotheticalFrequencyHz || -1;
    flowResultRows.value = theData.rows;
  }
};

const showRaw = (data: unknown) => {
  alert(JSON.stringify(data, null, 2));
};
</script>
